import { HttpClient, HttpEvent, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  constructor(
    private http: HttpClient,
    private router: Router
  ) { }
  public get<Type>(url, data = {}, reportProgress?: boolean, responseType?, observe?): Observable<Type> | Observable<HttpEvent<Type>> {
    const headers = this.getAuthHeader();
    // header.append("Content-Type", "")
    return this.http.get<Type>(url, {
      headers,
      responseType,
      observe: observe,
      reportProgress: reportProgress || false,
      params: data,
    })
    .pipe(
      map(
        (response: any) => {
          if (response.status == 0 && response.message == "Unauthorized")
            this.handleExpiredToken();
          return response
        }
      )
    )
  }
  getProgress(url, data?, type?): Observable<any> {
    return this.http.get(url, {
      params: this.setData(data),
      headers: this.getAuthHeader(),
      reportProgress: true,
      responseType: type,
      observe: 'events'
    });
  }
  public getJSON<Type>(url, data = {}, headers?: HttpHeaders, reportProgress?: boolean): Observable<Type> {
    return this.http.get<Type>(url, {
      reportProgress: reportProgress || false,
      params: this.setData(data),
      responseType: 'json',
      headers: this.getAuthHeader(),
    })
    .pipe(
      map(
        (response: any) => {
          if (response.status == 0 && response.message == "Unauthorized")
            this.handleExpiredToken();
          return response
        }
      )
    )
  }
  public post<Type>(url: string, data: { [key: string]: any } | FormData, headers?: HttpHeaders, reportProgress?: boolean, options?): Observable<Type> | Observable<HttpEvent<Type>> {
    return this.http.post<Type>(url, this.setData(data), {
      headers: this.getAuthHeader(),
      reportProgress: reportProgress || false,
      ...options
    })
    .pipe(
      map(
        (response: any) => {
          if (response.status == 0 && response.message == "Unauthorized")
            this.handleExpiredToken();
          return response
        }
      )
    )
  }
  public postJSON<Type>(url: string, data: { [key: string]: any } = {}, headers?: HttpHeaders, reportProgress?: boolean, options?): Observable<Type> {
    return this.http.post<Type>(url, this.setData(data), {
      headers: this.getAuthHeader(),
      reportProgress: reportProgress || false,
      responseType: 'json'
    })
    .pipe(
      map(
        (response: any) => {
          if (response.status == 0 && response.message == "Unauthorized")
            this.handleExpiredToken();
          return response
        }
      )
    )
  }
  public customPostJSON<Type>(url: string, data: { [key: string]: any } = {}, headers?: HttpHeaders, reportProgress?: boolean, options?): Observable<Type> {
    return this.http.post<Type>(url, this.setData(data), {
      headers: headers,
      reportProgress: reportProgress || false,
      responseType: 'json'
    })
    .pipe(
      map(
        (response: any) => {
          if (response.status == 0 && response.message == "Unauthorized")
            this.handleExpiredToken();
          return response
        }
      )
    )
  }
  public putJSON<Type>(url, data?, options?): Observable<Type> {
    const headers = this.getAuthHeader();
    headers.append("Content-Type", "application/json");
    return this.http.put<Type>(url, data, {
      responseType: 'json',
      headers
    })
  }
  public delete<Type>(url, data?, options?: { [key: string]: any }): Observable<Type> {
    const headers = this.getAuthHeader();
    headers.append("Content-Type", "application/json");
    return this.http.delete<Type>(url, {
      headers: headers,
      params: data,
      ...options
    })
  }
  // public putJSON<Type>(url, data?, options?: { [key: string]: any }): Observable<Type> {
  //   const headers = this.getAuthHeader();

  // }
  private setData(data: { [key: string]: any }) {
    for (let key in data) {
      if (typeof data[key] == "undefined")
        delete data[key] // REMOVE PROPERTY WHEN VALUE UNDEFINED
    }
    return data;
  }
  
  private getAuthHeader(): HttpHeaders {
    const token = 'Bearer ' + localStorage.getItem("token")
    return new HttpHeaders({
      Authorization: token
    });
  }

  private handleExpiredToken(): void {
    localStorage.clear();
    this.router.navigateByUrl("/auth/login")
  }
}
